import { useEffect, useState } from 'react';
import { venueTransform } from '../../../../../ui-kitchen/src/api/resyApiTransformer';
import { getVenue } from '../../../../../ui-kitchen/src/api/api';
import Logger from '../../../../../ui-kitchen/src/utils/logger';

const useVenueState = (venueId) => {
  const [venueState, setVenueState] = useState(null);
  useEffect(() => {
    // eslint-disable-next-line no-shadow
    const loadVenue = (venueId) => getVenue({ id: venueId })
      .then(
        (response) => {
          const venue = venueTransform(response);
          setVenueState(venue);
        }
      ).catch(
        (error) => {
          Logger.error('[VenuePage] useVenueState() failure: ', error);
        }
      );
    if (venueId) {
      loadVenue(venueId);
    }
  }, [venueId]);
  return venueState;
};

export default useVenueState;
